import React from 'react';
import styles from './ConfirmDialog.module.css';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ isOpen, title, message, onConfirm, onCancel }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.overlay} onClick={onCancel}>
      <div className={styles.dialog} onClick={(e) => e.stopPropagation()}>
        <h2>{title}</h2>
        <p>{message}</p>
        <div className={styles.buttonContainer}>
          <button onClick={onCancel} className={`${styles.button} ${styles.cancelButton}`}>
            إلغاء
          </button>
          <button onClick={onConfirm} className={`${styles.button} ${styles.confirmButton}`}>
            تأكيد الحذف
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
